export const qaData = {
  id: 'qa',
  title: 'QA Engineer',
  icon: 'Shield',
  color: 'from-green-500 to-emerald-600',
  description: 'Herramientas de testing, reportes y metodologías QA',
  categories: [
    {
      name: 'Testing Manual',
      icon: 'Target',
      resources: [
        {
          id: 'manual-1',
          title: 'Casos de Prueba - Plantillas',
          type: 'Plantillas',
          description: 'Plantillas y ejemplos de casos de prueba para diferentes tipos de aplicaciones y metodologías de testing.',
          tags: ['Testing Manual', 'Casos de Prueba', 'Plantillas'],
          difficulty: 'Básico',
          estimatedTime: '1h',
          lastUpdated: '2024-01-15',
          author: 'QA Team',
          downloads: 234,
          rating: 4.8,
          content: {
            sections: [
              {
                title: 'Estructura de Casos de Prueba',
                content: 'Componentes esenciales y estructura estándar para casos de prueba efectivos.',
                subsections: [
                  'Identificador único',
                  'Título descriptivo',
                  'Precondiciones',
                  'Pasos de ejecución',
                  'Resultados esperados',
                  'Criterios de aceptación'
                ]
              },
              {
                title: 'Plantillas por Tipo de Aplicación',
                content: 'Plantillas específicas adaptadas a diferentes tipos de aplicaciones y plataformas.',
                subsections: [
                  'Aplicaciones web',
                  'Aplicaciones móviles',
                  'APIs y servicios',
                  'Aplicaciones de escritorio',
                  'Sistemas embebidos'
                ]
              },
              {
                title: 'Ejemplos Prácticos',
                content: 'Ejemplos reales de casos de prueba para diferentes funcionalidades.',
                subsections: [
                  'Login y autenticación',
                  'CRUD operations',
                  'Validaciones de formularios',
                  'Navegación y routing',
                  'Integración de APIs'
                ]
              },
              {
                title: 'Mejores Prácticas',
                content: 'Recomendaciones y mejores prácticas para crear casos de prueba efectivos.',
                subsections: [
                  'Claridad y simplicidad',
                  'Reutilización de casos',
                  'Mantenimiento de plantillas',
                  'Versionado de casos',
                  'Colaboración en equipo'
                ]
              },
              {
                title: 'Checklists',
                content: 'Listas de verificación para validar la calidad de los casos de prueba.',
                subsections: [
                  'Revisión de casos',
                  'Validación de cobertura',
                  'Verificación de claridad',
                  'Comprobación de ejecutabilidad',
                  'Validación de resultados'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Plantillas-Casos-Prueba.zip',
              type: 'application/zip',
              size: 2048000
            },
            {
              name: 'Ejemplos-Casos-Prueba.pdf',
              type: 'application/pdf',
              size: 1536000
            }
          ],
          externalLinks: [
            {
              title: 'ISTQB Test Case Templates',
              description: 'Plantillas estándar de ISTQB para casos de prueba',
              url: 'https://www.istqb.org/certifications/certified-tester-foundation-level'
            }
          ]
        },
        {
          id: 'manual-2',
          title: 'Reportes de Bugs - Estándares',
          type: 'Estándares',
          description: 'Estándares y mejores prácticas para crear reportes de bugs efectivos y detallados.',
          tags: ['Reportes', 'Bugs', 'Estándares'],
          difficulty: 'Básico',
          estimatedTime: '1.5h',
          lastUpdated: '2024-01-12',
          author: 'QA Team',
          downloads: 189,
          rating: 4.7,
          content: {
            sections: [
              {
                title: 'Estructura del Reporte',
                content: 'Estructura estándar y componentes esenciales de un reporte de bug efectivo.',
                subsections: [
                  'Título descriptivo',
                  'Resumen ejecutivo',
                  'Descripción detallada',
                  'Información del entorno',
                  'Prioridad y severidad'
                ]
              },
              {
                title: 'Información Requerida',
                content: 'Información esencial que debe incluirse en cada reporte de bug.',
                subsections: [
                  'Datos del usuario',
                  'Configuración del sistema',
                  'Versión de la aplicación',
                  'Navegador y dispositivo',
                  'Pasos para reproducir'
                ]
              },
              {
                title: 'Pasos para Reproducir',
                content: 'Metodología para documentar pasos claros y reproducibles.',
                subsections: [
                  'Secuencia de pasos',
                  'Datos de entrada',
                  'Condiciones específicas',
                  'Orden de operaciones',
                  'Validación de pasos'
                ]
              },
              {
                title: 'Evidencia y Screenshots',
                content: 'Captura y documentación de evidencia visual del bug.',
                subsections: [
                  'Screenshots relevantes',
                  'Logs de error',
                  'Videos de reproducción',
                  'Archivos de ejemplo',
                  'Análisis de consola'
                ]
              },
              {
                title: 'Priorización',
                content: 'Sistema de priorización y clasificación de bugs según su impacto.',
                subsections: [
                  'Criterios de severidad',
                  'Matriz de priorización',
                  'Impacto en el negocio',
                  'Tiempo de resolución',
                  'Recursos requeridos'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Bug Reporting Best Practices',
              description: 'Mejores prácticas en reportes de bugs',
              url: 'https://www.softwaretestinghelp.com/bug-report-template/'
            }
          ]
        }
      ]
    },
    {
      name: 'Testing Automatizado',
      icon: 'Play',
      resources: [
        {
          id: 'selenium-1',
          title: 'Selenium WebDriver - Guía Completa',
          type: 'Tutorial',
          description: 'Implementación completa de tests automatizados con Selenium WebDriver, incluyendo frameworks y CI/CD.',
          tags: ['Selenium', 'WebDriver', 'Automation'],
          difficulty: 'Intermedio',
          estimatedTime: '3h',
          lastUpdated: '2024-01-10',
          author: 'Automation Team',
          downloads: 167,
          rating: 4.8,
          content: {
            sections: [
              {
                title: 'Configuración del Entorno',
                content: 'Setup completo del entorno de desarrollo para Selenium WebDriver.',
                subsections: [
                  'Instalación de WebDriver',
                  'Configuración de IDE',
                  'Dependencias del proyecto',
                  'Configuración de browsers',
                  'Variables de entorno'
                ]
              },
              {
                title: 'Locators y Selectores',
                content: 'Estrategias para localizar elementos de manera confiable en la interfaz web.',
                subsections: [
                  'ID y Name selectors',
                  'CSS selectors',
                  'XPath expressions',
                  'Relative locators',
                  'Custom locators'
                ]
              },
              {
                title: 'Page Object Model',
                content: 'Implementación del patrón Page Object Model para tests mantenibles.',
                subsections: [
                  'Page Object structure',
                  'Element locators',
                  'Page methods',
                  'Test organization',
                  'Maintenance strategies'
                ]
              },
              {
                title: 'Test Frameworks',
                content: 'Integración con frameworks de testing populares.',
                subsections: [
                  'TestNG integration',
                  'JUnit integration',
                  'PyTest integration',
                  'NUnit integration',
                  'Custom frameworks'
                ]
              },
              {
                title: 'CI/CD Integration',
                content: 'Integración de tests automatizados en pipelines de CI/CD.',
                subsections: [
                  'Jenkins integration',
                  'GitHub Actions',
                  'GitLab CI',
                  'Azure DevOps',
                  'Parallel execution'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Selenium-WebDriver-Guia.pdf',
              type: 'application/pdf',
              size: 3584000
            },
            {
              name: 'ejemplos-selenium.zip',
              type: 'application/zip',
              size: 2048000
            }
          ],
          externalLinks: [
            {
              title: 'Selenium Documentation',
              description: 'Documentación oficial de Selenium',
              url: 'https://www.selenium.dev/documentation/'
            }
          ]
        },
        {
          id: 'cypress-1',
          title: 'Cypress - Testing Moderno',
          type: 'Guía',
          description: 'Testing end-to-end moderno con Cypress para aplicaciones web complejas.',
          tags: ['Cypress', 'E2E Testing', 'JavaScript'],
          difficulty: 'Intermedio',
          estimatedTime: '2.5h',
          lastUpdated: '2024-01-16',
          author: 'Automation Team',
          downloads: 145,
          rating: 4.6,
          content: {
            sections: [
              {
                title: 'Instalación y Configuración',
                content: 'Setup inicial de Cypress en proyectos JavaScript y configuración del entorno.',
                subsections: [
                  'Package installation',
                  'Cypress configuration',
                  'Browser setup',
                  'Environment variables',
                  'Project structure'
                ]
              },
              {
                title: 'Writing Tests',
                content: 'Escritura de tests efectivos y mantenibles con Cypress.',
                subsections: [
                  'Test structure',
                  'Assertions',
                  'Selectors',
                  'Waiting strategies',
                  'Test data management'
                ]
              },
              {
                title: 'Custom Commands',
                content: 'Creación de comandos personalizados para reutilizar lógica común.',
                subsections: [
                  'Command syntax',
                  'Parameter passing',
                  'Return values',
                  'Command chaining',
                  'Best practices'
                ]
              },
              {
                title: 'Fixtures y Stubs',
                content: 'Uso de fixtures para datos de testing y stubs para APIs.',
                subsections: [
                  'Fixture files',
                  'Data management',
                  'API stubbing',
                  'Network mocking',
                  'Dynamic data'
                ]
              },
              {
                title: 'Visual Testing',
                content: 'Implementación de testing visual y regresiones en la UI.',
                subsections: [
                  'Screenshot testing',
                  'Visual regression',
                  'Percy integration',
                  'Baseline management',
                  'Visual debugging'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'Cypress Documentation',
              description: 'Documentación oficial de Cypress',
              url: 'https://docs.cypress.io/'
            }
          ]
        }
      ]
    },
    {
      name: 'Herramientas & Integración',
      icon: 'Wrench',
      resources: [
        {
          id: 'tools-1',
          title: 'Jira - Gestión de QA',
          type: 'Guía',
          description: 'Configuración y uso de Jira para optimizar procesos de QA y gestión de testing.',
          tags: ['Jira', 'QA', 'Gestión'],
          difficulty: 'Intermedio',
          estimatedTime: '2h',
          lastUpdated: '2024-01-08',
          author: 'Tools Team',
          downloads: 198,
          rating: 4.7,
          content: {
            sections: [
              {
                title: 'Configuración de Workflows',
                content: 'Diseño y configuración de workflows personalizados para procesos de QA.',
                subsections: [
                  'Workflow design',
                  'Status transitions',
                  'Conditions and validators',
                  'Post functions',
                  'Workflow optimization'
                ]
              },
              {
                title: 'Custom Fields',
                content: 'Creación y configuración de campos personalizados para necesidades específicas de QA.',
                subsections: [
                  'Field types',
                  'Field configuration',
                  'Validation rules',
                  'Default values',
                  'Field dependencies'
                ]
              },
              {
                title: 'Dashboards',
                content: 'Creación de dashboards personalizados para monitoreo de métricas de QA.',
                subsections: [
                  'Dashboard creation',
                  'Gadget configuration',
                  'Filter setup',
                  'Refresh settings',
                  'Dashboard sharing'
                ]
              },
              {
                title: 'Reporting',
                content: 'Generación de reportes y métricas para análisis de calidad.',
                subsections: [
                  'Built-in reports',
                  'Custom reports',
                  'Metrics calculation',
                  'Trend analysis',
                  'Export options'
                ]
              },
              {
                title: 'Integraciones',
                content: 'Integración de Jira con otras herramientas de testing y desarrollo.',
                subsections: [
                  'TestRail integration',
                  'Confluence integration',
                  'Slack integration',
                  'Git integration',
                  'CI/CD integration'
                ]
              }
            ]
          },
          attachments: [
            {
              name: 'Jira-QA-Configuracion.pdf',
              type: 'application/pdf',
              size: 2560000
            }
          ]
        },
        {
          id: 'tools-2',
          title: 'TestRail - Gestión de Testing',
          type: 'Tutorial',
          description: 'Uso efectivo de TestRail para gestión integral de casos de prueba y ejecución de tests.',
          tags: ['TestRail', 'Test Management', 'QA'],
          difficulty: 'Básico',
          estimatedTime: '1.5h',
          lastUpdated: '2024-01-18',
          author: 'Tools Team',
          downloads: 123,
          rating: 4.5,
          content: {
            sections: [
              {
                title: 'Configuración de Proyectos',
                content: 'Setup inicial de proyectos en TestRail y configuración de estructura.',
                subsections: [
                  'Project creation',
                  'Suite organization',
                  'Milestone setup',
                  'User management',
                  'Permission configuration'
                ]
              },
              {
                title: 'Creación de Casos de Prueba',
                content: 'Metodología para crear y organizar casos de prueba en TestRail.',
                subsections: [
                  'Case creation',
                  'Template usage',
                  'Case organization',
                  'Reusable cases',
                  'Case maintenance'
                ]
              },
              {
                title: 'Ejecución de Tests',
                content: 'Proceso de ejecución de tests y registro de resultados.',
                subsections: [
                  'Test execution',
                  'Result recording',
                  'Defect linking',
                  'Execution tracking',
                  'Progress monitoring'
                ]
              },
              {
                title: 'Reporting',
                content: 'Generación de reportes y análisis de resultados de testing.',
                subsections: [
                  'Built-in reports',
                  'Custom reports',
                  'Metrics analysis',
                  'Trend reporting',
                  'Export functionality'
                ]
              },
              {
                title: 'Integración con Jira',
                content: 'Configuración de integración bidireccional entre TestRail y Jira.',
                subsections: [
                  'Integration setup',
                  'Bidirectional sync',
                  'Defect management',
                  'Test case linking',
                  'Workflow automation'
                ]
              }
            ]
          },
          externalLinks: [
            {
              title: 'TestRail Documentation',
              description: 'Documentación oficial de TestRail',
              url: 'https://docs.testrail.com/'
            }
          ]
        }
      ]
    }
  ]
};
